import { render, staticRenderFns } from "./IndividualContactModal.vue?vue&type=template&id=5bb60ce8&scoped=true&"
import script from "./IndividualContactModal.vue?vue&type=script&lang=js&"
export * from "./IndividualContactModal.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContactModal.vue?vue&type=style&index=0&id=5bb60ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb60ce8",
  null
  
)

export default component.exports